// METIS Hub wording — namespace "stats" (en), 382 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/stats.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const stats: Record<string, string> = {
  "stats.kicker.me": "My insights",
  "stats.kicker.team": "My team · {team}",
  "stats.kicker.all": "Company-wide",
  "stats.kicker.allTeam": "Everyone · {team} only",
  "stats.kicker.view": "Saved view",
  "stats.title": "Insights: {item}",
  "stats.desc": "{range} · Korea time · as of {asof}",
  "stats.tabs": "Insight items",
  "stats.loading": "Applying conditions",
  "stats.cond.tool": "Tool",
  "stats.cond.toolAll": "All tools",
  "stats.cond.model": "AI model",
  "stats.cond.modelAll": "All AI models",
  "stats.cond.button": "Filters",
  "stats.cond.buttonN": "Filters {n}",
  "stats.cond.title": "Filters",
  "stats.cond.clear": "Clear filters",
  "stats.cond.cleared": "Filters cleared",
  "stats.cond.applied": "Filters applied",
  "stats.cond.modelNote": "The AI model filter picks conversations that used that model.",
  "stats.cond.scope": "This card’s scope: {scope}",
  "stats.small.title": "Small-group protection is on",
  "stats.small.body": "Only {n} people remain under these conditions, so hourly, AI active time and per-person values are hidden (your own records excepted).",
  "stats.small.threshold": "These conditions do not meet the minimum group size of {n}, so hourly, AI active time and per-person values are hidden (your own records excepted).",
  "stats.small.more": "What is small-group protection?",
  "stats.smallTeams": "Small teams combined",
  "stats.total": "Total",
  "stats.bar.open": "Click to open the activity for this period",
  "stats.overall": "Whole period",
  "stats.col.when": "Time",
  "stats.cell.none": "No record",
  "stats.sample.few": "Too few samples",
  "stats.views.button": "Saved views",
  "stats.views.title": "Saved views",
  "stats.views.none": "You haven’t saved a view yet.",
  "stats.views.sample": "Sample",
  "stats.views.mine": "My views",
  "stats.views.share": "Links are re-checked against the receiver’s permissions and view scope. Only the creator sees and edits a view in this list.",
  "stats.views.save": "Save current view",
  "stats.views.saveTitle": "Save the current view?",
  "stats.views.saveLead": "Keeps the item tab (or card list), card options, common filters and view scope. Periods are saved as relative values like “Last 30 days”.",
  "stats.views.name": "View name",
  "stats.views.namePh": "e.g. Weekly team report",
  "stats.views.nameErr": "Enter a name for the view.",
  "stats.views.saved": "Saved the view “{name}”",
  "stats.views.what": "Saving: {what}",
  "stats.views.delete": "Delete",
  "stats.views.deleteTitle": "Delete this view?",
  "stats.views.deleteBody": "Only the view “{name}” is deleted. Records and other people’s views stay as they are.",
  "stats.views.deleted": "View deleted",
  "stats.views.cards": "{n|card|cards}",
  "stats.views.tab": "{item} tab",
  "stats.views.sum": "{what} · {period} · {scope}",
  "stats.views.cond": "{period} · {scope}",
  "stats.view.close": "Close view",
  "stats.view.missing": "Couldn’t find this saved view. Only its creator can open it.",
  "stats.view.scopeDown": "Opened with the view scope “{scope}”, re-checked against your permissions.",
  "stats.view.hidden": "Some cards are hidden because you lack permission ({n}).",
  "stats.view.edited": "Options you change here can be kept as a new view with [Save current view].",
  "stats.seed.weekly": "Weekly team report",
  "stats.seed.codex": "My Codex usage",
  "stats.addView.title": "Add to saved view",
  "stats.addView.lead": "Adds this card with its current options. One view can collect cards from several items.",
  "stats.addView.pick": "Add to",
  "stats.addView.new": "Create a new view",
  "stats.addView.newName": "New view name",
  "stats.addView.defaultName": "My insights board",
  "stats.addView.added": "Added this card to “{name}”",
  "stats.addView.updated": "“{name}” already had this card, so only its options changed",
  "stats.addView.sampleNote": "Sample views can’t be changed. Add to your own view or a new one.",
  "stats.addView.add": "Add",
  "stats.export.title": "Export this card",
  "stats.export.lead": "Downloads the card’s table as is. By default it uses pseudonyms and no text, and the download is recorded in the access & change log.",
  "stats.export.fmt": "Format",
  "stats.export.preview": "Preview (first lines)",
  "stats.export.rows": "{n|row|rows} · with header · no file is kept on the server",
  "stats.export.get": "Download",
  "stats.export.done": "Exported. Recorded in the access & change log.",
  "stats.export.none": "There are no numbers to export.",
  "stats.export.noPerm": "You can’t export this view scope",
  "stats.export.h1": "METIS Hub insights export · {id}",
  "stats.export.h2": "Exported by role: {role} · {time} (Korea time)",
  "stats.export.h3": "Card: {q} ({card}) · metric dictionary v1",
  "stats.export.h4": "Conditions: {cond} · View scope: {scope}",
  "stats.export.h5": "Prohibited use: usage statistics are for cost and security management, never for evaluating work or performance · No record ≠ not used",
  "stats.export.h6": "Masking: names outside your permission are pseudonyms, no question or answer text · cells with fewer than 3 people show <3",
  "stats.opt.by": "Compare by",
  "stats.opt.bars": "Bars by",
  "stats.opt.metric": "Metric",
  "stats.opt.agg": "Aggregation",
  "stats.opt.bucket": "Time unit",
  "stats.opt.scope": "View scope (this card)",
  "stats.opt.toggles": "Display",
  "stats.opt.periodHelp": "Changes the period for this card only. If it differs from the common period, a “This card only” chip appears.",
  "stats.opt.aggHelp": "Counts and usage use total or per person; lengths and times use typical or average. Per person = total ÷ people with records in that series.",
  "stats.opt.scopeHelp": "File cards start at “Me”. When widened, folder names still need the files permission and at least 3 people.",
  "stats.opt.topHelp": "Donuts always show 5 slices + Other.",
  "stats.opt.prevHelp": "Overlays the previous period of the same length as a dashed line.",
  "stats.opt.hide0": "Hide zero days",
  "stats.opt.hide0.desc": "Only confirmed zeros are hidden. Spans with no record always show.",
  "stats.opt.split": "Split opened / edited",
  "stats.opt.split.desc": "Stacks opened and edited files for each extension.",
  "stats.opt.splitTool": "Split by tool",
  "stats.opt.splitTool.desc": "Stacks the Claude Code and Codex share for each action type.",
  "stats.opt.unoff": "Show unofficial estimate (Codex)",
  "stats.opt.unoff.desc": "Not in the official docs, so it’s collapsed by default.",
  "stats.opt.reset": "Options you can’t use here were opened with their defaults.",
  "stats.opt.hourClamp": "Hourly buckets only work for periods of 7 days or less, so this is drawn by day.",
  "stats.bucket.auto": "Auto",
  "stats.bucket.hour": "Hour",
  "stats.bucket.day": "Day",
  "stats.bucket.week": "Week",
  "stats.bucket.month": "Month",
  "stats.bucket.help": "Korea time; weeks start on Monday. Hourly buckets only for periods of 7 days or less.",
  "stats.agg.sum": "Total",
  "stats.agg.perPerson": "Per person",
  "stats.agg.avg": "Average",
  "stats.agg.p50": "Typical",
  "stats.agg.p95": "Slow",
  "stats.disp.auto": "Auto",
  "stats.disp.raw": "Tokens",
  "stats.disp.k": "Thousands",
  "stats.disp.man": "×10K",
  "stats.disp.m": "Millions",
  "stats.chart.stackedBar": "Stacked bars",
  "stats.chart.bar": "Bars",
  "stats.chart.line": "Lines",
  "stats.chart.stackedArea": "Stacked area",
  "stats.chart.table": "Table",
  "stats.chart.heatmap": "Heatmap",
  "stats.chart.donut": "Donut",
  "stats.chart.hbar": "Horizontal bars",
  "stats.chart.histogram": "Distribution",
  "stats.chart.pct100": "100% bars",
  "stats.chart.diverging": "Bars (added up · removed down)",
  "stats.by.kind": "Usage type",
  "stats.by.dis": "{label} — {reason}",
  "stats.by.cliOnly": "CLI tools only",
  "stats.audit.export": "Insights · {card} · {fmt} {n|row|rows} (pseudonymous, no text)",
  "stats.chip.prev": "Previous period",
  "stats.chip.prevOff": "Previous period off",
  "stats.chip.hide0": "Zero days hidden",
  "stats.chip.top": "Top {n}",
  "stats.chip.more": "+{n} more",
  "stats.m.perConv": "Questions per conversation",
  "stats.m.lines": "Lines added & removed",
  "stats.m.commits": "Commits & PRs",
  "stats.m.failRate": "Failure rate",
  "stats.m.latency": "Wait time (typical & slow)",
  "stats.m.tokens4": "Usage, 4 types",
  "stats.m.costAs": "As cost · {kind}",
  "stats.m.filesByExt": "Files by extension",
  "stats.m.linesByExt": "Lines by extension (Codex)",
  "stats.m.tokensShare": "Share of usage",
  "stats.m.promptsShare": "Share of questions",
  "stats.m.costShare": "Share of cost · {kind}",
  "stats.m.apiTokens": "Usage (API key calls)",
  "stats.m.errorKinds": "AI call errors & tool failures",
  "stats.m.errors": "Failed requests & refusals",
  "stats.m.rejects": "Rejected actions",
  "stats.kind.in": "Newly read",
  "stats.kind.outEx": "Written by AI (excl. thinking)",
  "stats.kind.reason": "Thinking (included in written)",
  "stats.kind.reasonCol": "of which thinking (not added)",
  "stats.kind.added": "Lines added",
  "stats.kind.removed": "Lines removed",
  "stats.codexEst": "Codex (estimated)",
  "stats.commits": "Commits",
  "stats.prs": "PRs",
  "stats.person.sum": "{metric} for {n|person|people}, in name order (not a ranking).",
  "stats.person.not": "Only the per-person comparison is unavailable. Team and company totals still show.",
  "stats.empty.cond.not": "There may be records under other conditions.",
  "stats.empty.cond.next": "Loosen conditions",
  "stats.empty.connect": "Connect tools",
  "stats.empty.wider": "Widen to {p}",
  "stats.empty.small.what": "This chart is hidden because fewer than 3 people remain.",
  "stats.empty.small.not": "It doesn’t mean there are no records — it keeps people from being identified. Try a longer period or a wider team scope.",
  "stats.empty.small.next": "Widen to 90 days",
  "stats.empty.small.allTeams": "Widen to all teams",
  "stats.empty.level.what": "No records from people who keep work details (file paths).",
  "stats.empty.level.not": "It doesn’t mean no files were touched. Only people at recording level ④ (work details) are counted.",
  "stats.empty.level.next": "About recording levels",
  "stats.empty.codexActive.what": "Codex doesn’t send AI active time.",
  "stats.empty.codexActive.not": "It doesn’t mean Codex wasn’t used.",
  "stats.empty.support": "Open the support table",
  "stats.empty.gw.what": "Only calls through the gateway are shown per person.",
  "stats.empty.gw.not": "It doesn’t mean API keys weren’t used.",
  "stats.empty.gw.next": "How to connect an app",
  "stats.empty.cliOnly.what": "The “How used” filter is CLI tool, so API key calls are left out.",
  "stats.empty.apiOnly.what": "The “How used” filter is API key call, so nothing here applies.",
  "stats.empty.apiOnly.not": "API key calls have no files, changes, AI actions or AI active time (not applicable to this usage method).",
  "stats.empty.perConvApi": "API key calls have no conversations, so questions per conversation can’t be counted.",
  "stats.empty.commits.what": "Commits and PRs only come from Claude Code metrics.",
  "stats.c.promptsTrend.q": "How many questions went to AI?",
  "stats.c.promptsTrend.qPerson": "How many questions did each person ask?",
  "stats.c.promptsTrend.tech": "{metric} · by {by} · {chart}",
  "stats.c.promptsTrend.techPerson": "{metric} · by person · name order (not a ranking)",
  "stats.c.promptsTrend.def": "Questions, not counting slash commands. Each API key call counts as one question (call count).",
  "stats.c.promptsTrend.formula": "Questions = question events (excl. /commands) · per conversation = questions in one conversation (typical/average)",
  "stats.c.promptsTrend.sum": "{p}: {n|question|questions} to AI.",
  "stats.c.promptsTrend.sumPer": "{p}: {v} questions per person ({total} ÷ {people} people).",
  "stats.c.promptsTrend.sumSlash": "{p}: {n|slash command|slash commands} used.",
  "stats.c.promptsTrend.sumSlashPer": "{p}: {v} slash commands per person ({total} ÷ {people} people).",
  "stats.c.promptsTrend.sumLen": "Questions are {how} {v} long ({n|question|questions}).",
  "stats.c.promptsTrend.sumConv": "{how} {v} questions per conversation ({n|conversation|conversations}).",
  "stats.c.promptsTrend.apiNote": "Each API key call counts as one question (call count).",
  "stats.how.p50": "typically",
  "stats.how.avg": "on average",
  "stats.c.promptsHeat.q": "When are most questions asked?",
  "stats.c.promptsHeat.tech": "Weekday × hour · when questions were sent (Korea time)",
  "stats.c.promptsHeat.sum": "Most questions came around {h} on {wd} ({n}).",
  "stats.c.promptsHeat.note": "Managers and admins see hours only as totals. Hidden when fewer than 3 people remain.",
  "stats.col.weekday": "Weekday",
  "stats.c.usageTrend.q": "How did usage change?",
  "stats.c.usageTrend.techKind": "Usage (tokens) · {chart} by type · thinking dotted (not added)",
  "stats.c.usageTrend.techBy": "Usage (tokens) · by {by} · {chart}",
  "stats.c.usageTrend.techCost": "As cost · {kind} · by {by} · {chart}",
  "stats.c.usageTrend.formula": "Usage = newly read + read from cache + saved to cache + written by AI (thinking included). Codex cache writes aren’t stacked (3 types).",
  "stats.c.usageTrend.sum": "{p}: usage was {v}.",
  "stats.c.usageTrend.sumCost": "{p}: {kind} cost was {v}.",
  "stats.c.usageTrend.reasonNote": "Thinking ({v}) is inside “written by AI”, so it isn’t added to the total.",
  "stats.c.usageTrend.reasonNone": "Thinking:",
  "stats.c.usageTrend.perNote": "Per person = total ÷ the {n|person|people} with records under these conditions",
  "stats.c.usageTrend.sumPer": "Usage per person {p} is {v} (based on {n|person|people} with records).",
  "stats.opt.topTrend": "The chart splits up to 5 colors plus “Other”; the table view keeps all top N.",
  "reasonDetail.no_gateway": "This key doesn’t go through the gateway, so there’s no price-table value on our side",
  "reasonDetail.no_org": "Not in the org report yet (the report arrives a day late)",
  "reasonDetail.no_compare": "One side is missing, so no difference was calculated",
  "stats.c.usageTrend.codexNote": "Codex “saved to cache” isn’t stacked until we confirm it isn’t already in the input.",
  "stats.c.usageTrend.costNote": "Different cost types are never added together. Pick one type to show usage as that amount.",
  "stats.c.usageTop.q": "Which models and tools used the most?",
  "stats.c.usageTop.qPerson": "How much did each person use?",
  "stats.c.usageTop.tech": "{metric} · top {n} by {by} + Other",
  "stats.c.usageTop.techRatio": "Cache reuse ratio · top {n} by {by}",
  "stats.c.usageTop.techPerson": "Usage (tokens) · by person · name order (not a ranking)",
  "stats.c.usageTop.formula": "Cache reuse ratio = read from cache ÷ (newly read + read from cache + saved to cache)",
  "stats.c.usageTop.sum": "{pct} of usage came from {name} ({v}/{total}).",
  "stats.c.usageTop.sumRatio": "{name} has the highest cache reuse ratio ({pct}).",
  "stats.c.usageTop.readOf": "of {v} read",
  "stats.kpi.total": "Total usage (tokens)",
  "stats.kpi.totalHint": "Usage total · reasoning excluded (three kinds for Codex)",
  "stats.kpi.ratio": "Cache reuse ratio",
  "stats.kpi.ratioHint": "Read from cache {a} ÷ read {b}",
  "stats.kpi.reason": "Thinking (included)",
  "stats.kpi.reasonHint": "Inside written by AI ({out})",
  "stats.kpi.cost": "CLI tool estimated cost",
  "stats.kpi.costHint": "Estimate · not a bill · price-table cost {b} separately",
  "stats.c.filesExt.q": "What kinds of files did AI work with?",
  "stats.c.filesExt.tech": "{metric} · by extension · {chart}",
  "stats.c.filesExt.techSplit": "Opened / edited by extension · horizontal bars",
  "stats.c.filesExt.def": "Counts only file actions the AI tools reported at recording level ④ (work details).",
  "stats.c.filesExt.sum": "{ext} files are the most common ({pct}, {v}/{total}).",
  "stats.c.filesExt.note": "Only actions the AI tools report are recorded. Files opened with shell commands may be missing.",
  "stats.c.filesExt.read": "Opened",
  "stats.c.filesExt.edited": "Edited",
  "stats.c.filesFolders.q": "Which folders came up most?",
  "stats.c.filesFolders.tech": "Files by folder · last two path parts · top {n} + Other",
  "stats.c.filesFolders.sum": "The most-used folder is {name} ({v}).",
  "stats.c.filesFolders.sumHidden": "Files in {n|folder|folders}. Folder names need permission.",
  "stats.c.filesFolders.hidden": "Folder names show only with the files permission and at least 3 people.",
  "stats.col.folder": "Folder",
  "stats.col.ext": "Extension",
  "stats.c.changesLines.q": "How much code changed?",
  "stats.c.changesLines.tech": "Lines added & removed · by tool · added up, removed down",
  "stats.c.changesLines.techOther": "{metric} · by tool · {chart}",
  "stats.c.changesLines.def": "Not an AI contribution rate. Claude Code sends metrics; Codex lines are estimated from patches.",
  "stats.c.changesLines.sum": "{p}: Claude Code added {a} lines and removed {r}.",
  "stats.c.changesLines.sumCodex": "Codex, estimated from patches, added {a} and removed {r}.",
  "stats.c.changesLines.sumCount": "{p}: {metric} {n}.",
  "stats.c.changesLines.sumCommits": "{p}: {c|commit|commits} and {r|PR|PRs}.",
  "stats.c.changesLines.metricsOff": "{n|record has|records have} no line counts because Claude Code metrics export is off.",
  "stats.c.changesLines.refetch": "Get settings again",
  "stats.c.changesLines.axis": "Up: lines added · Down: lines removed",
  "stats.c.changesLines.noPerson": "Never split by person.",
  "stats.c.changesExt.q": "Which file types changed most?",
  "stats.c.changesExt.tech": "Edited files by extension · top {n} + Other",
  "stats.c.changesExt.techLines": "Lines by extension · Codex only (estimated from patches)",
  "stats.c.changesExt.def": "Files changed by shell commands and whole-file diffs can’t be recorded.",
  "stats.c.changesExt.sum": "{ext} is the most edited file type ({pct}, {v}/{total}).",
  "stats.c.changesExt.sumLines": "Codex changed {ext} files the most (+{a} / −{r} lines).",
  "stats.c.timeActive.q": "How long was AI in active use?",
  "stats.c.timeActive.tech": "AI active time (Claude only) · {by} · {chart}",
  "stats.c.timeActive.sum": "{p}: AI active time was {v}.",
  "stats.c.timeActive.sumPer": "{p}: AI active time was {v} per person ({total} ÷ {people} people).",
  "stats.c.timeOpen.q": "How long were conversations open?",
  "stats.c.timeOpen.tech": "Time the chat was open · 6-bucket distribution",
  "stats.c.timeOpen.sum": "Most conversations were open {bin} ({n}). Typical: {med}.",
  "stats.col.bin": "Time open",
  "stats.col.convs": "Conversations",
  "stats.bin.0": "under 5 min",
  "stats.bin.1": "5–15 min",
  "stats.bin.2": "15–30 min",
  "stats.bin.3": "30 min–1 h",
  "stats.bin.4": "1–2 h",
  "stats.bin.5": "2 h or more",
  "stats.binShort.0": "<5m",
  "stats.binShort.1": "5–15m",
  "stats.binShort.2": "15–30m",
  "stats.binShort.3": "30–60m",
  "stats.binShort.4": "1–2h",
  "stats.binShort.5": "2h+",
  "stats.c.timeWait.q": "How long did answers take?",
  "stats.c.timeWait.tech": "Wait time · typical & slow · successful requests only",
  "stats.c.timeWait.techBy": "Wait time ({agg}) · by {by} · successful requests only",
  "stats.c.timeWait.techFirst": "Time to first text · typical · successful requests only",
  "stats.c.timeWait.formula": "Typical = half finish within this time (p50) · Slow = 95 of 100 finish within this time (p95)",
  "stats.c.timeWait.sum": "Answers typically took {a}, {b} when slow ({n|request|requests}).",
  "stats.c.timeWait.sumFirst": "The first text typically arrived after {a} ({n|request|requests}).",
  "stats.c.timeWait.few": "Too few requests ({n}) to compute typical and slow times.",
  "stats.c.timeWait.approx": "Periods longer than 31 days are approximated from bucket counts.",
  "stats.c.timeWait.sample": "Buckets with fewer than 5 requests are left blank (too few samples).",
  "stats.approx": "Approx.",
  "stats.noun.tokens": "usage",
  "stats.noun.prompts": "questions",
  "stats.noun.cost": "{kind} cost",
  "stats.c.modelsShare.q": "Which AI models were used?",
  "stats.c.modelsShare.tech": "AI model · {metric} · 5 slices + Other",
  "stats.c.modelsShare.sum": "{pct} of {metric} came from {model} ({v}/{total}).",
  "stats.c.modelsShare.note": "Model names as sent by the CLI tools and the gateway. Questions count toward the conversation’s main model.",
  "stats.c.modelsTrend.q": "How did models and thinking depth change?",
  "stats.c.modelsTrend.tech": "{metric} · stacked by {by}",
  "stats.c.modelsTrend.sum": "{pct} of {metric} had {by} “{name}” ({v}/{total}).",
  "stats.c.modelsTrend.note": "Requests without a thinking depth go to “Not confirmed”; API key calls go to “Not applicable”.",
  "stats.c.actionsKinds.q": "What did AI do?",
  "stats.c.actionsKinds.tech": "{metric} · top {n} by action type + Other",
  "stats.c.actionsKinds.techCmd": "Commands run · by tool",
  "stats.c.actionsKinds.sum": "{kind} is the most common of {n|action|actions} ({pct}).",
  "stats.c.actionsKinds.sumFail": "{f} of {n|action|actions} failed ({pct}).",
  "stats.c.actionsKinds.sumCmd": "AI ran {n|command|commands}.",
  "stats.c.actionsKinds.note": "Hover a bar name to see the original tool names. Codex counts success per tool call.",
  "stats.c.actionsKinds.failOf": "{f}/{n} failed",
  "stats.c.actionsDecisions.q": "Who allowed or rejected actions?",
  "stats.c.actionsDecisions.tech": "Allowed / rejected × who decided · 100% bars",
  "stats.c.actionsDecisions.sum": "{actor} decided {pct} of {n|allowed action|allowed actions} ({v}/{n}).",
  "stats.c.actionsDecisions.sumNone": "No allow or reject records under these conditions.",
  "stats.c.actionsDecisions.n": "{n|time|times}",
  "stats.c.actionsDecisions.note": "Codex batch runs have no decision record, so they count as “Not recorded”.",
  "stats.c.actionsErrors.q": "How many errors, rejections and retries?",
  "stats.c.actionsErrors.tech": "{metric} · by {by} · {chart}",
  "stats.c.actionsErrors.sum": "{p}: {metric} {n}.",
  "stats.c.actionsErrors.note": "Claude counts one failure after retries; Codex counts every failed attempt. So tools are shown side by side, never combined.",
  "stats.c.apiCalls.q": "How much was AI called with API keys?",
  "stats.c.apiCalls.tech": "{metric} · by {by} · {chart} · through the gateway",
  "stats.c.apiCalls.techLat": "Wait time · typical & slow · gateway",
  "stats.c.apiCalls.sum": "{p}: {n|call|calls} with API keys.",
  "stats.c.apiCalls.sumTok": "{p}: API key call usage was {v}.",
  "stats.c.apiCalls.gw": "CLI (via gateway) {n|call|calls} · checking duplicates · not added to any total",
  "stats.c.apiCalls.note": "Only calls through the gateway are shown per person. The org report is in the card below.",
  "stats.c.apiRec.q": "Does it match the org report?",
  "stats.c.apiRec.qMe": "What does the org report say for my keys?",
  "stats.c.apiRec.qTeam": "What does the org report say for my team’s keys?",
  "stats.c.apiRec.tech": "Price-table cost ↔ org billing · date × AI model × API key",
  "stats.c.apiRec.techLim": "Org report · daily · not per person",
  "stats.c.apiRec.sum": "Of {n|cell|cells}: match {a} · small gap {b} · large gap {c} · not in our records {d} · not in the report {e}.",
  "stats.c.apiRec.sumLim": "{k|key|keys} · {days|day|days} · usage {tok} · billing basis {usd}",
  "stats.c.apiRec.limNote": "Billing reconciliation needs the cost permission (everyone).",
  "stats.c.apiRec.note": "Daily · not per person · CLI subscription use isn’t reconciled. Without a gateway-only workspace a gap always remains.",
  "stats.rec.when": "Date · AI model · key",
  "stats.rec.ours": "Price-table cost",
  "stats.rec.org": "Org billing",
  "stats.rec.diff": "Gap",
  "stats.rec.status": "Status",
  "stats.rec.key": "API key",
  "stats.rec.ok": "Match",
  "stats.rec.small": "Small gap",
  "stats.rec.big": "Large gap",
  "stats.rec.noOurs": "Not in our records",
  "stats.rec.noOrg": "Not in the report",
  "stats.rec.more": "Show {n} more rows",
  "stats.rec.less": "Show less",
  "stats.rec.noKey": "Key grouping not provided",
  "stats.c.apiCosts.q": "Where did the cost come from?",
  "stats.c.apiCosts.tech": "By cost type · side by side · never added together",
  "stats.c.apiCosts.sum": "{list}. These are never added together.",
  "stats.c.apiCosts.part": "{kind}: {v}",
  "stats.c.apiCosts.none": "No cost records under these conditions.",
  "stats.c.apiCosts.sub.cli_estimate": "Estimate · not a bill · amount sent by Claude Code",
  "stats.c.apiCosts.sub.unofficial": "Unofficial estimate · Codex’s own figure",
  "stats.c.apiCosts.sub.gateway_price": "Gateway usage × price table · not a bill",
  "stats.c.apiCosts.sub.org_bill": "Billing basis · daily · not per person",
  "stats.c.apiCosts.unoffHidden": "The unofficial estimate (Codex) is collapsed. Show it from [Options].",
  "stats.col.kind": "Cost type",
  "stats.col.cost": "Amount",
};

export default stats;
